export default {
  InventoryCategoryList: {
    InventoryCategory: 'Loại vật tư/CCDC',
    DictionaryInventoryCategory: '/ Kho / Loại vật tư/ CCDC',
    Dictionary: 'Danh mục',
    TextPlaceholder: {
      Search: 'Tìm kiếm theo Mã loại, Tên loại',
    },
  },
  InventoryCategoryDetail: {
    Text: {
      InventoryCategoryCode: 'Mã loại *',
      InventoryCategoryName: 'Tên loại *',
      IsTool: 'Là loại công cụ dụng cụ',
    },
    Combobox: {
      Title: {
        InventoryCategory: 'Thuộc loại',
      },
    },
  },
};
